import clsx from 'clsx';
import styles from './Content.module.scss';
import { type ReactNode } from 'react';

interface Props {
  alignX?: 'start' | 'center' | 'end';
  alignY?: 'start' | 'center' | 'end';
  children: ReactNode;
  flow?: 'horizontal' | 'vertical';
  spacing?: 'XS' | 'S' | 'M' | 'L' | 'XL';
}

// Lays its children out along `flow`. `alignX` and `alignY` always refer to
// the screen's horizontal and vertical axes, whichever way the flow goes.
export function Content({
  alignX = 'start',
  alignY = 'start',
  children,
  flow = 'vertical',
  spacing,
}: Props) {
  const className = clsx(
    styles['root'],
    styles[`flow-${flow}`],
    styles[`align-x-${alignX}`],
    styles[`align-y-${alignY}`],
    spacing && styles[`spacing-${spacing}`],
  );

  return <div className={className}>{children}</div>;
}
